import flow from "lodash/fp/flow";
import get from "lodash/fp/get";
import getOr from "lodash/fp/getOr";
import head from "lodash/fp/head";
import values from "lodash/fp/values";

import selectUserChoiceValues from "./selectUserChoiceValues";
import selectSelectedProduct from "./selectSelectedProduct";
import selectDefaultValues from "./selectDefaultValues";
import { filterSkus } from "utils";

export function getProductSku({ selectedProduct, userChoicesValues }) {
  return flow(
    getOr({}, ["skus"]),
    values,
    filterSkus(userChoicesValues),
    head,
    get("sku")
  )(selectedProduct);
}

export default function selectProductSku(state) {
  const selectedProduct = selectSelectedProduct(state);
  const userChoicesValues = selectUserChoiceValues(state);
  const defaultValues = selectDefaultValues(state);

  return getProductSku({
    selectedProduct,
    userChoicesValues: { ...defaultValues, ...userChoicesValues },
  });
}
